var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreatActor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x9C\xB3\xEF\xB8\x8F start icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.10958 9.46111L7.62257 5.22993C7.95336 4.30484 8.9571 3.8076 9.89348 4.10495L12.6235 4.9719C12.8082 5.03054 13.0068 5.02888 13.1904 4.96715L15.7171 4.11798C16.6303 3.81107 17.6247 4.26676 17.9885 5.15881L19.743 9.46111H19.7249C21.9465 9.94507 23.3533 10.662 23.3533 11.462C23.3533 12.9195 18.685 14.101 12.9263 14.101C7.1676 14.101 2.49927 12.9195 2.49927 11.462C2.49927 10.662 3.90601 9.94507 6.12764 9.46111H6.10958Z",
    fill: "url(#paint0_linear_14611_176799)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.27746 18.2424L5.49186 16.2435C5.4784 16.2092 5.4698 16.1727 5.48486 16.1391C5.55124 15.9912 5.90038 15.6022 5.90038 15.6022C5.90038 15.6022 6.04327 15.4446 6.22444 15.2808C6.31738 15.1968 6.44186 15.1584 6.56691 15.1663C9.35593 15.341 11.8811 15.4226 12.8723 15.4391C13.6496 15.452 17.382 15.2908 19.3939 15.154C19.5556 15.143 19.7101 15.2179 19.8019 15.3515L20.2903 16.1391C20.3122 16.1939 20.3193 16.1939 20.2903 16.2435L19.5252 18.365C19.3338 18.7382 18.1846 19.411 15.7803 19.9805C15.7278 19.9929 15.6739 20.0009 15.62 20.0021C15.157 20.0119 14.2712 19.9223 13.6031 19.5172C13.4191 19.4057 13.2142 19.324 12.9991 19.324H12.8615C12.6652 19.324 12.4763 19.3912 12.307 19.4908C11.698 19.8488 10.9941 19.9735 10.6225 19.9957C10.5632 19.9992 10.5026 19.9937 10.4442 19.983C7.59536 19.4607 6.58818 18.83 6.37232 18.4865C6.34164 18.4377 6.32406 18.3824 6.30647 18.3271C6.2974 18.2986 6.28833 18.27 6.27746 18.2424ZM11.1872 17.4574C11.1872 17.9564 10.4479 18.361 9.53586 18.361C8.62386 18.361 7.88454 17.9564 7.88454 17.4574C7.88454 16.9583 8.62386 16.5537 9.53586 16.5537C10.4479 16.5537 11.1872 16.9583 11.1872 17.4574ZM16.3287 18.361C17.2407 18.361 17.98 17.9564 17.98 17.4574C17.98 16.9583 17.2407 16.5537 16.3287 16.5537C15.4167 16.5537 14.6774 16.9583 14.6774 17.4574C14.6774 17.9564 15.4167 18.361 16.3287 18.361Z",
    fill: "url(#paint1_linear_14611_176799)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14611_176799",
    x1: 2.49927,
    y1: 4.01892,
    x2: 17.934,
    y2: 24.1565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0054EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0343B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14611_176799",
    x1: 2.49927,
    y1: 4.01892,
    x2: 17.934,
    y2: 24.1565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0054EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0343B7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreatActor);
export default __webpack_public_path__ + "static/media/threatActor.2495fd2e45111f530708698a8659d949.svg";
export { ForwardRef as ReactComponent };